AU.basic = true;

AU.ipure = {
  source: {

  }
};

AU.design.setMagnificPopup = function () {
  return;
};

AU.databox = {
  init: function () {
    return;
  }
};

AU.flowbox = {
  init: function () {
    return;
  }
};

AU.alphabox = {
  boxes: [],
  init: function () {
    return;
  }
};

AU.piechart = {
  init: function () {
    return;
  }
};

AU.social = {
  init: function () {
    return;
  }
};

AU.news = {
  feeds: [],
  init: function () {
    return;
  }
};